import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
} from "@angular/core";
import {
  NotificationService,
  Notification,
} from "../../services/notification.service";
import { Subject, takeUntil } from "rxjs";

export interface CloneNotificationData {
  isCloning: boolean;
  folderName: string;
  folderId: string;
  currentItem: number;
  totalItems: number;
  percentage: number;
}

@Component({
  selector: "app-clone-notification-panel",
  templateUrl: "./clone-notification-panel.component.html",
  styleUrls: ["./clone-notification-panel.component.scss"],
})
export class CloneNotificationPanelComponent implements OnInit, OnDestroy {
  @Input() show: boolean = false;
  @Input() cloneData!: CloneNotificationData;

  @Output() close = new EventEmitter<void>();
  @Output() openFolder = new EventEmitter<void>();
  @Output() openFolderNewTab = new EventEmitter<void>();
  @Output() viewAll = new EventEmitter<void>();

  notifications: Notification[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private notificationService: NotificationService,
    private elementRef: ElementRef,
  ) {}

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.show) return;

    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    const clickedOnNotificationIcon = (event.target as HTMLElement).closest(
      ".notifications",
    );

    if (!clickedInside && !clickedOnNotificationIcon) {
      this.onClose();
    }
  }

  ngOnInit() {
    // Subscribe to notifications
    this.notificationService.notifications$
      .pipe(takeUntil(this.destroy$))
      .subscribe((notifications) => {
        this.notifications = notifications;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onClose() {
    this.close.emit();
  }

  onOpenFolder() {
    this.openFolder.emit();
  }

  onOpenFolderNewTab() {
    this.openFolderNewTab.emit();
  }

  onViewAll() {
    this.viewAll.emit();
  }

  clearAll() {
    this.notificationService.clearCompletedNotifications();
  }

  removeNotification(id: string) {
    this.notificationService.removeNotification(id);
  }

  getStatusIcon(status: string): string {
    switch (status) {
      case "in-progress":
        return "/assets/images/folder-clone-progress.svg";
      case "completed":
        return "/assets/images/folder-clone-success.svg";
      case "failed":
        return "/assets/images/notification.svg"; // Using generic icon, replace if specific icon exists
      default:
        return "/assets/images/notification.svg";
    }
  }

  hasCompletedNotifications(): boolean {
    return this.notifications.some(
      (n) => n.status === "completed" || n.status === "failed",
    );
  }
}
